import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getRelevantSkus } from "../../../services/sku";
import SkusSlider from "../../SkusSlider/SkusSlider";

const RelevantSkusSlider = (props) => {
  const { skuId } = props;
  const [relevantSkus, setRelevantSkus] = useState([]);
  const [isRelevantSkusLoading, setIsRelevantSkusLoading] = useState(true);

  useEffect(() => {
    const fetchRelevantSkus = async () => {
      try {
        setIsRelevantSkusLoading(true);
        const response = await getRelevantSkus(skuId);
        const {
          data: { skuList },
        } = response;
        setRelevantSkus(skuList);
      } catch (err) {
        console.error(err);
      } finally {
        setIsRelevantSkusLoading(false);
      }
    };
    if (skuId) {
      fetchRelevantSkus();
    }
  }, [skuId]);

  return (
    <SkusSlider
      isLoading={isRelevantSkusLoading}
      title="منتجات ذات صلة"
      skus={relevantSkus}
    />
  );
};

export default RelevantSkusSlider;

RelevantSkusSlider.propTypes = {
  skuId: PropTypes.number,
};
